import { Badge, Group, Text } from "@mantine/core";
import { FiltroDesafio } from "./ModalFilterDesafios";

interface FiltrosAtivosProperties {
  filtros: FiltroDesafio;
  totalResultados?: number;
}

const FiltrosAtivos = ({ filtros, totalResultados }: FiltrosAtivosProperties) => {
  const filtrosAtivos: string[] = [];

  // Verificar filtros ativos
  if (filtros.status) {
    const statusLabels: Record<string, string> = {
      DRAFT: "Rascunho",
      NOVO_DESAFIO: "Novo Desafio",
      PROPOSTO_PELO_COLABORADOR: "Proposto pelo Colaborador",
      PRE_ANALISE: "Pré-análise",
      ANALISE_DE_VIABILIDADE: "Análise de Viabilidade",
      AGUARDANDO_ANALISE_DO_COMITE: "Aguardando Análise do Comitê",
      APROVADO_PELO_COMITE: "Aprovado pelo Comitê",
      AGENDADO: "Agendado",
      RECUSADO_PELO_COMITE: "Recusado pelo Comitê",
      BACKLOG_PARA_AVALIACAO_FUTURA: "Backlog para Avaliação Futura",
      EM_REALIZACAO: "Em Realização",
      REALIZADO: "Realizado",
      SOLUCOES_VALIDADAS: "Soluções Validadas",
      CANCELADA: "Cancelada"
    };
    filtrosAtivos.push(`Status: ${statusLabels[filtros.status] || filtros.status}`);
  }

  if (filtros.search && filtros.campo) {
    filtrosAtivos.push(`${filtros.campo}: "${filtros.search}"`);
  }

  if (filtrosAtivos.length === 0) {
    return (
      <Group gap="xs">
        <Text size="sm" c="dimmed">
          Nenhum filtro aplicado
        </Text>
      </Group>
    );
  }

  return (
    <Group gap="xs">
      <Text size="sm" c="dimmed">
        Filtros ativos:
      </Text>
      {filtrosAtivos.map((filtro, index) => (
        <Badge key={index} variant="light" size="sm">
          {filtro}
        </Badge>
      ))}
      {totalResultados !== undefined && (
        <Text size="sm" c="dimmed">
          • {totalResultados} resultado{totalResultados === 1 ? "" : "s"} encontrado{totalResultados === 1 ? "" : "s"}
        </Text>
      )}
    </Group>
  );
};

export default FiltrosAtivos;
